import { Paragraph } from 'grommet'
import styled from 'styled-components'

export const TextError = styled(Paragraph)`
  color: ${({ color, theme }) => theme.colors[color] || color};
  font-weight: ${({ fontWeight }) => fontWeight};
  margin-left: ${({ marginLeft }) => marginLeft};
  margin-top: ${({ marginTop }) => marginTop};
  width: 100%;

  ${({ theme }) => theme.below.tablet`
    font-size: ${theme.fontSizes[2]}px;
    line-height: ${theme.fontSizes[2]}px;
  `}

  ${({ theme }) => theme.below.mobileL`
    font-size: ${theme.fontSizes[0]}px;
    line-height: ${theme.fontSizes[0]}px;
  `}
`
